import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { toIdString } from '../../../utils'
import { useTranslation } from '../../../utils/providers'

function QtySelect({
  productId,
  qty,
  setQty,
  name = 'qty',
  min = 1,
  max = 10,
  disabled,
  className,
}) {
  const { t } = useTranslation()

  const handleChange = (e) =>
    e?.target?.value && setQty(parseInt(e.target.value))

  const options = []
  for (let i = min; i <= max; i++) options.push(i)

  const htmlId = toIdString(`${name}-${productId}`)
  const cls = classNames('form-control', className)

  return (
    <>
      <label htmlFor={htmlId} className="sr-only">
        {t('QTY_SELECT_LABEL')}
      </label>
      <select
        className={cls}
        onChange={handleChange}
        name={name}
        id={htmlId}
        value={qty}
        disabled={disabled}
      >
        {options.map((o) => (
          <option key={o} value={o}>
            {o}
          </option>
        ))}
      </select>
    </>
  )
}

QtySelect.propTypes = {
  productId: PropTypes.string.isRequired,
  qty: PropTypes.number.isRequired,
  setQty: PropTypes.func.isRequired,
  name: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  disabled: PropTypes.bool,
  className: PropTypes.string,
}

export default QtySelect
